import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { StepElements } from '../_models';
import { StepEmulatorService } from '../_services/step-emulator.service';

@Directive({
  selector: '[stepElement]'
})
export class StepElementDirective implements OnInit {
  @Input() stepElement: StepElements;

  constructor(
    private el: ElementRef,
    private stepEmulator: StepEmulatorService
  ) {}

  ngOnInit() {
    this.stepEmulator.registerElement(this.stepElement, this.el.nativeElement);
  }
}
